query TravelerAuthorizationFilterData {
  companyCurrencies(orderBy: [ISO_CODE_ASC]) {
    nodes {
      id
      name
      isoCode
    }
  }
  availableTripWorkgroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyBusinessUnits(orderBy: [NAME_ASC]) {
    nodes {
      id
      name
      companyAddress {
        addressAlias
        addressLine1
        addressLine2
        cityName
        postalCode
      }
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      userDepartment {
        _isUserAssigned
      }
    }
  }
  travelAuthorizationStatusTypes(orderBy: STATUS_TYPE_ASC) {
    nodes {
      id
      statusType
    }
  }
   travelAuthorizationUsers(orderBy: [USER_NAME_ASC]) {
    nodes {
      userId
      userName
    }
  }
}
